<template>
  <b-form-select
    v-bind="$attrs"
    :options="options"
    @change="handleChange"
    v-model="selectProfile"
    class="form-control"
  >
    <template #first>
      <b-form-select-option :value="null">
        Selecione o perfil
      </b-form-select-option>
    </template>
  </b-form-select>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      selectProfile: this.value,
      options: [
        { value: 'consumer', text: 'Consumidor' },
        { value: 'trader', text: 'Promotor' },
        { value: 'investor', text: 'Investidor' },
      ],
    };
  },
  methods: {
    handleChange() {
      this.$emit('input', this.selectProfile);
    },
  },
};
</script>
